import { ref } from 'vue'

const createProductTemplatesFilters = () => ({
    name: null
})

export function createProductTemplatesState() {
    return {
        productTemplates: ref([]),
        productTemplatesLoading: ref(false),
        productTemplatesFilters: ref(createProductTemplatesFilters()),
        productionFileInPaths: ref([]),
        foldingTypes: ref([]),

        createProductTemplatesFilters
    }
}
